import { createTheme, Modal } from "@mantine/core";

// Extracted from index.tsx so other modules (e.g. the Colour Tint picker's
// brand-gold swatch) can read the exact same palette instead of duplicating
// a hex value that could drift out of sync with this one.
export const theme = createTheme({
  fontFamily: "Quicksand, sans-serif",
  headings: { fontFamily: "Cinzel, serif", fontWeight: "500" },
  primaryColor: "brand-gold",
  primaryShade: { light: 6, dark: 5 },
  defaultRadius: "lg",
  components: {
    // Every <Modal> in the app centers by default now, instead of most
    // call sites passing centered individually (and a few not) - one
    // place to get this right rather than relitigating it per modal.
    // modals.openConfirmModal/open (@mantine/modals) is a separate
    // system with its own default (see ModalsProvider's modalProps in
    // index.tsx), not covered by this.
    Modal: Modal.extend({ defaultProps: { centered: true } }),
  },
  colors: {
    "brand-blue": [
      "#eff2ff",
      "#dfe2f2",
      "#bdc2de",
      "#99a0ca",
      "#7a84b9",
      "#6672af",
      "#5c69ac",
      "#4c5897",
      "#424e88",
      "#36437a",
    ],
    // Warm brass/gold — a softer, more editorial accent than a saturated
    // "alert" orange, echoing the RememQR app's ink-on-parchment identity.
    "brand-gold": [
      "#fdf6ea",
      "#f9ecd2",
      "#f2d9a8",
      "#eac47c",
      "#e2b158",
      "#dca23f",
      "#d69a44",
      "#b37e26",
      "#8f6520",
      "#6b4b18",
    ],
    "brand-gray": [
      "#f1f4fe",
      "#e4e6ed",
      "#c8cad3",
      "#a9adb9",
      "#9094a3",
      "#7f8496",
      "#777c91",
      "#656a7e",
      "#595e72",
      "#4a5167",
    ],
    // Warm ink neutrals replacing Mantine's default cool blue-gray "dark"
    // scale, so the dark theme reads as warm charcoal rather than slate.
    dark: [
      "#cbc6bf",
      "#aea99f",
      "#948e84",
      "#777166",
      "#544e45",
      "#403a32",
      "#332e27",
      "#241f1a",
      "#191510",
      "#120f0c",
    ],
  },
});
